import { graphql } from '~/lib/graphql'

export const RestaurantAccesses = graphql(`
  fragment RestaurantAccesses on Restaurant {
    restaurantId
    accesses {
      __typename
      ... on RestaurantAccessTrain {
        line
        station
        note
      }
      ... on RestaurantAccessCar {
        note
      }
    }
    area {
      displayName
      mediumName
    }
    parking {
      availability
      note
    }
  }
`)
